export default __webpack_public_path__ + "static/media/pexels-thorsten-technoman-338504.364c7de7.jpg";